(function () {
    'use strict';

    function excludeByArray() {
        return function (items, arrayProperty, arrayItems) {
            return items.filter(function(item) {
                return arrayItems.indexOf(item[arrayProperty]) === -1;
            });
        };
    }

    angular.module('ecap.common').filter('excludeByArray', excludeByArray);
})();